import { PropTypes } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Icon, Icons } from '@ge/components/icon';
import { Placeholders } from '@ge/models/constants';

const PageTitle = styled.h1`
  margin-bottom: 32px;
`;

const MAHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 2px solid ${(props) => props.theme.analyze.manualAdjustment.bordersColor};
  margin-bottom: 12px;
`;

const MySites = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
`;

const MySitesHeading = styled.h2`
  margin-right: 15px;
`;

const SitesCounts = styled.div`
  display: flex;
  align-items: center;
`;

const SitesIcons = styled(Icon).attrs((props) => ({
  size: props.size || 22,
  color: props.theme.analyze.manualAdjustment.iconsColor,
}))`
  margin-right: 4px;
`;

const Count = styled.span`
  margin-right: 14px;
  display: inline-block;
  font-size: 16px;
`;

export const CRContractsHeader = ({ data }) => {
  const { t, ready } = useTranslation(['analyze.cr-tracker'], {
    useSuspense: false,
  });

  if (!ready) return null;

  return (
    <>
      <PageTitle>{t('page_title', 'Contractual Availability')}</PageTitle>
      <MAHeaderContainer>
        <MySites>
          <MySitesHeading>{t('my_sites', 'My Contracts')}</MySitesHeading>
          <SitesCounts>
            <SitesIcons icon={Icons.SITE} />
            <Count>{data?.length ?? Placeholders.DOUBLE_DASH}</Count>
          </SitesCounts>
          <SitesCounts>
            <SitesIcons icon={Icons.TURBINE} />
            <Count>
              {data?.reduce((count, contract) => (count += contract?.srcassetid?.length || 0), 0) ??
                Placeholders.DOUBLE_DASH}
            </Count>
          </SitesCounts>
        </MySites>
      </MAHeaderContainer>
    </>
  );
};

CRContractsHeader.propTypes = {
  data: PropTypes.object.isRequired,
};
